import React, { useState } from 'react';
import { Box } from '@mui/material';
import SavingsIcon from '@mui/icons-material/Savings';
import BudgetManager from './BudgetManager';
import PageHeader from '../common/PageHeader';
import SegmentedControl from '../common/SegmentedControl';

const viewOptions = [
  { value: 'list', label: 'List' },
  { value: 'matrix', label: 'Matrix' }
];

const Budgets = () => {
  // layoutMode lifted to header (list | matrix)
  const [layoutMode, setLayoutMode] = useState('list');

  return (
    <Box sx={{ width: '100%' }}>
      <PageHeader
        title="Budgets"
        icon={<SavingsIcon fontSize="large" />}
        actions={
          <SegmentedControl
            options={viewOptions}
            value={layoutMode}
            onChange={setLayoutMode}
          />
        }
      />
      <BudgetManager layoutMode={layoutMode} setLayoutMode={setLayoutMode} />
    </Box>
  );
};

export default Budgets;
